module.exports = __webpack_public_path__ + "static/DAWN1-03f01bcc56abab121136848c18cc6213.jpg";